module.exports = __webpack_public_path__ + "static/kgawronska-medinvest-813cea802f9ba21e7cf1dcd45bfd3d62.jpg";